import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { Subject, Observable } from 'rxjs';
import { YetiSocket } from '../yeti-socket';
import { environment } from 'src/environments/environment';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Injectable({
	providedIn: 'root'
})
export class MessageReadService {
	private echo: Echo<any>;

	constructor() {
		this.echo = YetiSocket.connect();
	}

	public listener(data?: IMessageRead): Observable<IMessageReadResponse> {
		if (!data?.type || !data.id) {
			return new Observable();
		}
		const subject = new Subject<IMessageReadResponse>();
		const channelEvent = environment.socketChannel;
		const listenEvent = StringHelper.sprintf('.message_read_%s_%d', data.type, data.id);
		this.echo
			.channel(channelEvent)
			.listen(listenEvent, (response:any) => subject.next(response));
		return subject.asObservable();
	}
}

interface IMessageRead {
	id?: number;
	type?: string;
}

interface IMessageReadResponse {
	message_ids: Array<number>;
}
